const Handlebars = require('handlebars/runtime');
//const Handlebars = require('handlebars-template-loader/runtime');
Handlebars.registerHelper('eq', (arg1, arg2, options) => {
    console.log(options.fn(this));
    return (arg1 === arg2) ? options.fn(this) : options.inverse(this);
});
Handlebars.registerHelper('getCompany', function () {
    let result = '';
    if (this.company) result += this.company;
    if (this.alias && this.company !== this.alias) result += ` (${this.alias})`;
    return result;
});
Handlebars.registerHelper('getPhone', function () {
    let result = '';
    if (this.mobile) result += `+${this.mobile}`;
    if (this.phone && this.mobile !== this.phone) result += `, +${this.phone}`;
    if (this.extension) result += ` × ${this.extension}`;
    return result;
});
Handlebars.registerHelper('getMail', function () {
    let result = '';
    if (this.mail) result += this.mail;
    if (this.personal && this.mail !== this.personal) result += `, ${this.personal}`;
    return result;
});
module.exports = Handlebars;